import React from 'react';
import './LoadingSpinner.scss';

interface LoadingSpinnerProps {
  /** Size of the spinner */
  size?: 'small' | 'medium' | 'large';
  /** Optional message to display below spinner */
  message?: string;
  /** Whether to center in a full-height container */
  fullHeight?: boolean;
  /** Additional CSS class */
  className?: string;
}

/**
 * Standardized loading spinner component
 * Uses Klyx primary color and theme background
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message,
  fullHeight = false,
  className = '',
}) => {
  return (
    <div className={`loading-spinner-container ${fullHeight ? 'full-height' : ''} ${className}`}>
      <div className={`loading-spinner loading-spinner-${size}`}></div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
